<template>
  <div class="box-card" shadow="never"
       :body-style="{ backgroundColor: '#F6F8FB', padding: '0' }">
    <ul class="left-item">
      <li :class="currentSelectLeftItemKey === item.key ? 'li-active' : ''" @click="leftAsideItemClick(item,idx)"
          v-for="(item,idx) in leftItems.filter(leftItem=>!leftItem.hide)">
        <div class="text" v-if="badgeCount">
        <el-badge :value="badgeCount" size="mini">
            {{ item.name }}
        </el-badge>
        </div>
        <div class="text" v-else>
            {{ item.name }}
        </div>

      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "LeftBar",
  props:["leftItems","currentSelectLeftItemKey",'badgeCount'],
  data(){
    return {
      itemSelectID:0,
      // leftItems:[
      //   {
      //     id:0,
      //     name:"业绩表现",
      //     key:"performance"
      //   },
      //   {
      //     id:1,
      //     name:"企业资产",
      //     key:"asset"
      //   }
      // ],
    }
  },
  methods:{
    leftAsideItemClick(item,idx){
      // console.log('leftAsideItemClick',item.id)
      // this.itemSelectID = item.id
      this.$emit('selectChange',item.key)
    }
  }
}
</script>

<style scoped lang="scss">
.left-item{
  /* 分隔线原来偏深（#D8D8D8），和浅蓝的选中态不在一个色温上，换成中性浅灰 */
  border-right: solid 1px #E9EDF3;
}
.box-card {
  width: 100%;
  height: 100%;

ul {
  height: 100% !important;
  overflow-y: auto;

li {
  position: relative;
//width: 272px;
  font-size: 16px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: #3F464E;
  border-bottom: 1px solid rgba(213, 215, 223, .5);
// &:last-of-type{
    //   border: none;
    // }
cursor: default;

&:hover {
   cursor: pointer;
   /* hover 也回到蓝体系里（原来 #EBEFF7 偏灰紫），比选中态再浅一档 */
   background: #F2F7FE;
 }

.text {
  font-size: 16px;
.el-input .el-input__count .el-input__count-inner {
  background: none;
}

.el-input__inner {
  height: 50px;
//width: 272px;
  background: #EBEFF7;
  border: none;
// border-left:1px solid rgba(57, 148, 241, .5);
  padding-left: 4px;
  margin-left: -30px;
  padding-left: 30px;
  font-size: 16px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  border-radius: 0;
// color: #3994F1;
}

input::-webkit-input-placeholder {
  font-size: 16px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: rgba(57, 148, 241, .4);
}

  font-size: 16px;
  display: flex;
  align-items: center;
  line-height: 24px;
  padding: 13px 16px 13px 30px;

.dot {
  width: 10px;
  height: 10px;
  margin-right: 6px;
}
}

.btn {
  position: absolute;
  right: 30px;
  top: 19px;
}

}

/* 三级蓝：左侧菜单是页面内的第三层导航，选中态取蓝梯级里最轻的一档 ——
   浅蓝底 + 主题蓝字 + 左侧 3px 竖条，而不是原来整块 #429FFF 实心蓝
   （那个蓝既不在「主蓝 #2783EF / 次蓝 #4E96F0」的体系里，压一整条也太重）。
   蓝的层级：主 #2783EF（顶栏）> 次 #4E96F0（页签）> 三级（本处） */
.li-active {
  background-color: #EAF3FF;
  color: #2273D2;
  font-weight: 600;
  box-shadow: inset 3px 0 0 #5B9BF2;

&:hover {
   background-color: #E3EFFF;
   color: #2273D2;
 }
}
}
}
</style>
